
        <footer class="page-footer white darken-3">
            <div class="footer-copyright black">
              <div class="container" *ngFor="let item of copyright">
                <span [innerHTML]="item.copyright"> </span>
              <!-- © 2021| <a class="white-text" href="http://sanskrit.uohyd.ac.in/faculty/amba" target="_blank">Amba Kulkarni</a> -->
              <a class="grey-text text-lighten-4 right waves-effect waves-light modal-trigger" href="#modal1">Contributors</a>
              </div>
            </div>
          </footer>
              


          <!-- Modal Structure -->
  <div id="modal1" class="modal modal-fixed-footer">
    <div class="modal-content">

      <h6 class="pink-text modal-title" *ngFor="let list of contList"> {{list.heading}}</h6><hr>
      <h5> Editors</h5>
      <table *ngFor="let item2 of contList" class="responsive-table">
        <tr *ngFor="let item of item2.editors"> 
          <td>
            <span class="title" [innerHTML]="item.name" style="font-weight: bold;"></span>
          </td>
          <td>
              {{item.responsibility}}
          </td>
          <td>
              {{item.email}}
          </td>
          <td>
              {{item.address}}
          </td>
        </tr>
      </table>

      <!-- <hr> -->
      <h5> Volunteers</h5>

      <!-- <ul class="collection"  *ngFor="let item2 of contList">
        <li class="collection-item" *ngFor="let item of item2.volunteers">

          <div class="row">
            <div class="col l2 s2 right">
            </div>
            <div class="col l10 s10">
              <span class="title" [innerHTML]="item.name" style="font-weight:bold"></span><br>
              <span> 
                {{item.responsibility}} <br>
                {{item.email}} <br>
                {{item.address}}
              </span>
            </div>
          </div>
        

          
        </li>

       
      </ul> -->
      <hr>
      <ul class="collection22"  *ngFor="let item2 of contList">
        <li class="collection-item22" *ngFor="let item of item2.volunteers2">
          <span class="title" [innerHTML]="item.heading" style="font-weight:bold"></span><br>
        </li>
      </ul>

      
    </div>
    <div class="modal-footer">
      <a href="#!" class="modal-close waves-effect waves-green btn-flat">Close</a>
    </div>
  </div>
          